export const adminMenuItems = ["Device Status", "Latest Samples", "MeterCode Panel", "Meter Readings", "Meter Values", "Register New Meter", "Alerts Check"]


export const adminMenuUrls = () => {
   return adminMenuItems.map((menuItem: string)=>  menuItem.split(' ').join('-').toLocaleLowerCase())
 
}